import React from 'react';
import { HeroSection } from './components/HeroSection';
import { IdentificationSection } from './components/IdentificationSection';
import { ProblemSection } from './components/ProblemSection';
import { WhyFailedSection } from './components/WhyFailedSection';
import { SolutionSection } from './components/SolutionSection';
import { MechanismSection } from './components/MechanismSection';
import { BenefitsSection } from './components/BenefitsSection';
import { StorySection } from './components/StorySection';
import { IncludesSection } from './components/IncludesSection';
import { BonusSection } from './components/BonusSection';
import { ObjectionsSection } from './components/ObjectionsSection';
import { GuaranteeSection } from './components/GuaranteeSection';
import { PricingSection } from './components/PricingSection';
import { FinalCtaSection } from './components/FinalCtaSection';
import { ClosingSection } from './components/ClosingSection';
import { DisclaimerSection } from './components/DisclaimerSection';
export function App() {
  return <div className="min-h-screen flex flex-col w-full overflow-x-hidden" data-id="element-0">
      <HeroSection data-id="element-1" />
      <IdentificationSection data-id="element-2" />
      <ProblemSection data-id="element-3" />
      <WhyFailedSection data-id="element-4" />
      <SolutionSection data-id="element-5" />
      <MechanismSection data-id="element-6" />
      <BenefitsSection data-id="element-7" />
      <StorySection data-id="element-8" />
      <IncludesSection data-id="element-9" />
      <BonusSection data-id="element-10" />
      <ObjectionsSection data-id="element-11" />
      <GuaranteeSection data-id="element-12" />
      <PricingSection data-id="element-13" />
      <FinalCtaSection data-id="element-14" />
      <ClosingSection data-id="element-15" />
      <DisclaimerSection data-id="element-16" />
    </div>;
}